import styled from 'styled-components'
import CommonStyles from 'shared/style/commonPageStyles'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	AreaDiv: CommonStyles.AreaDiv,
	AreaHeader: CommonStyles.AreaHeader,
	Input: styled.input`
		${({theme}) => theme.font.small};
		padding: 8px 20px;
		border: 1px solid ${({theme}) => theme.color.grey3};
		border-radius: 8px;
		outline: none;
		font-size: 12px;
		height: 30px;
		width: 100%;
		&:focus {
			border-color: ${({theme}) => theme.color.major};
		}

		&::placeholder {
			color: ${({theme}) => theme.color.grey3};
		}
	`,
	Select: styled.select`
		${({theme}) => theme.font.small};
		padding: 0px 20px;
		border: 1px solid ${({theme}) => theme.color.grey3};
		border-radius: 8px;
		outline: none;
		font-size: 12px;
		height: 30px;
		width: 100%;
		background-color: transparent;
		&:focus {
			border-color: ${({theme}) => theme.color.major};
		}
	`,
	ErrorText: styled.p`
		color: ${({theme}) => theme.color.error || '#ef4444'};
		font-size: 12px;
		margin-top: 4px;
		margin-bottom: 0;
	`,
	InputWrapper: styled.div`
		padding: 8px;
		flex-grow: 1;
		display: flex;
		flex-direction: column;
	`,
}

export default Style
